import { render, staticRenderFns } from "./TabelaCadastros.vue?vue&type=template&id=00b9e722&scoped=true"
import script from "./TabelaCadastros.vue?vue&type=script&lang=js"
export * from "./TabelaCadastros.vue?vue&type=script&lang=js"
import style0 from "./TabelaCadastros.vue?vue&type=style&index=0&id=00b9e722&prod&lang=css"
import style1 from "./TabelaCadastros.vue?vue&type=style&index=1&id=00b9e722&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b9e722",
  null
  
)

export default component.exports